import(/* webpackMode: "eager", webpackExports: ["PageCodeOfConduct"] */ "/home/runner/work/Mitobyte/Mitobyte/src/app/code-of-conduct/__page__/PageCodeOfConduct.tsx");
